// Assumes you are importing via build directory
import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider'
import indexInParent from '../utilities/indexInParent'

window.addEventListener('frame-ready', init)

function init() {

    let parent = document.querySelector('.product-range-details--gallery')

    if(parent) {

        let mainImages = parent.querySelector('.gallery--active')
        let thumbImages = parent.querySelector('.gallery--navigation')
        let variantText = Array.from(document.querySelectorAll('.product-navigation--items p[data-nav]'))

        let slider = tns({
            container: mainImages,
            navContainer: thumbImages,
            mode: 'gallery',
            controls: false
        })

        /*let navigation = tns({
            container: thumbImages,
            items: 5,
            controls: false,
            slideBy: 1
        })*/

        // Handles thumbnail hover effect to change slides
        Array.from(thumbImages.querySelectorAll('.gallery--navigation--thumbnail')).forEach( thumbnail => {
            thumbnail.addEventListener('mouseenter', e => {
                slider.goTo(e.target.getAttribute('data-nav'))
            })
        })

        // Handles hover effect on list of product variants
        if(variantText.length > 0) {
            variantText.forEach(element => {
                element.addEventListener('mouseenter', e => {
                for (var i = 0; i < variantText.length; i++) {
                    if (variantText[i] == e.target) {
                        // Get the id of the image from the product variant
                        let nav = e.target.getAttribute('data-nav')

                        // Check it exists
                        if (nav) {

                            // Get the image in the slider using that id
                            let item = document.querySelector(`[data-nav-id="${nav}"]`)

                            // Get the slider index and slide to it
                            slider.goTo(item.getAttribute('data-nav'))
                        }
                    }
                }
                })
            })
        }
    }
}
